import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { GQLFontAsset, GQLFontAssetInput, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorComponent, JwlCheckbox, JwlField, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  party: GQLParty;
  fontAsset: GQLFontAsset;
  onClose: (success: boolean) => void;
}

export const FontUpdateDialog: React.FC<IProps> = ({ party, fontAsset, onClose }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [fontToPersist, setFontToPersist] = useState(null as any);
  const initialValues = {
    name: fontAsset.font.name,
    public: fontAsset.public
  };

  const [
    updateFont,
    { error: errorCreatingFont, loading: createFontLoader }
  ] = GQLOperationBuilder.font.updateFont();

  const onSubmit = (props: any) => {
    const input: GQLFontAssetInput = {
      ownerPartyId: party.id,
      public: props.public,
      name: props.name
    };

    const mutationVariables = { input: input, fontId: fontAsset.id };

    setFontToPersist(props);
    updateFont({ variables: mutationVariables }).then(_ => {
      toast.success('Font updated successfully', {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      onClose(true);
    });
  };

  if (errorCreatingFont && !errorComponentState)
    return (
      <Dialog open={true} maxWidth="md" aria-labelledby="add-font">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => onSubmit(fontToPersist)}
          details={errorCreatingFont?.stack}
          message={errorCreatingFont?.message}
        />
      </Dialog>
    );

  if (createFontLoader) return <LoadingSpinner />;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required')
  });

  return (
    <Dialog open={true} aria-labelledby="add-font">
      <Fragment>
        <DialogTitle>Font update</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ ...initialValues }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, touched, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name" component={JwlField} label="Name" />
                <Field
                  name="public"
                  component={JwlCheckbox}
                  label="Public"
                  value={fontAsset.public ? 'checked' : ''}
                />

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false)}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default FontUpdateDialog;
